module.exports = __webpack_public_path__ + "img/PL08544.b988c327.png";